<h1 class="border-bottom">{{ 'NOTIFICATIONS' | translate }}</h1>

<div class="table-align-center">
  <div>
    <div>{{ 'CODE' | translate }}</div>
    <div>{{ problem?.id }}</div>
  </div>

  <div>
    <div>{{ 'DATE_PUBLICATION' | translate }}</div>
    <div>{{ problem?.publishDate | date: 'HH:mm dd-MM-yyyy' }}</div>
  </div>

  <div>
    <div>{{ 'PLANED_DATE_FIX' | translate }}</div>
    <div>{{ problem?.fixDate | date: 'HH:mm dd-MM-yyyy' }}</div>
  </div>

  <div>
    <div>{{ 'TIME_ELIMINATION' | translate }}</div>
    <div>{{ getTimeLeft() }}</div>
  </div>

  <div>
    <div>{{ 'TITLE' | translate }}</div>
    <div>{{ problem?.title }}</div>
  </div>

  <div>
    <div>{{ 'DESCRIPTION' | translate }}</div>
    <div>{{ problem?.description }}</div>
  </div>

  <div>
    <div></div>
    <div class="pt-2">
      @if (problem.image) {
        <img [src]="convertImage(problem)" style="max-width: 250px" />
      }
    </div>
  </div>
</div>
